import { getAutomationPerformanceAnalytics } from "@redotech/redo-merchant-marketing-rpc/schema/get-automation-performance-analytics";
import * as z from "zod";

export const getTeamAutomationPerformance = {
  name: "getTeamAutomationPerformance" as const,
  input: getAutomationPerformanceAnalytics.input.extend({
    teamId: z.string(),
    userId: z.string(),
    automationId: z.string().optional(),
  }),
  output: getAutomationPerformanceAnalytics.output,
};
